import React, {useState} from 'react';
import {Documents} from './Documents';

export const Footer: React.FC = () => {
    const currentYear = new Date().getFullYear();
    const [isAboutOpen, setIsAboutOpen] = useState(false);

    // Folosim hash-ul URL-ului pentru a controla starea popup-ului
    const [isContactOpen, setIsContactOpen] = useState(window.location.hash === '#contact-popup');

    const toggleAboutPopup = () => {
        setIsAboutOpen(!isAboutOpen);
    };

    const toggleContactPopup = () => {
        if (isContactOpen) {
            window.history.pushState(
                "",
                document.title,
                window.location.pathname + window.location.search
            );
        } else {
            window.location.hash = 'contact-popup';
        }
        setIsContactOpen(!isContactOpen);
    };

    // Adăugăm un event listener pentru a urmări schimbările hash-ului
    React.useEffect(() => {
        const handleHashChange = () => {
            setIsContactOpen(window.location.hash === '#contact-popup');
        };

        window.addEventListener('hashchange', handleHashChange);
        return () => window.removeEventListener('hashchange', handleHashChange);
    }, []);

    return (
        <footer className="footer bg-bg-gray min-h-[200px] flex flex-col items-center justify-end pt-3">
            <Documents/>
            {/* Button to open the About Us popup */}
            <div className="contact-info flex flex-row items-center gap-3 mb-4">
                <button
                    onClick={toggleAboutPopup}
                    className="text-text-color hover:text-blue-600 transition-colors p-2 text-base"
                >
                    {'Despre noi'}
                </button>
                <button
                    onClick={toggleContactPopup}
                    className="text-text-color hover:text-blue-600 transition-colors p-2 text-base"
                    id={'contact'}
                >
                    {'Contact'}
                </button>
                <a
                    href="https://www.renomia.ro/informatii-utile#form-solidpixels-1"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-text-color hover:text-blue-600 transition-colors p-2 text-base"
                >
                    {'Petitii'}
                </a>
            </div>
            {/* Footer copy */}
            <div className="footer-copy flex items-center justify-center mb-5">
                <p className="text-text-color text-base">&copy; {currentYear} Star Insurance</p>
            </div>

            {/* Popup Modal for About Us */}
            {isAboutOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white p-5 rounded-md shadow-md w-11/12 max-w-lg">
                        <h3 className="text-xl font-bold mb-4">{'Despre noi'}</h3>
                        <p className="text-base text-text-color">
                            {'www.starinsurance.ro este operat de către societatea comercială STAR INSURANCE ' +
                                'SPECIALIST SRL, care este înregistrată în Registrul Comerțului sub nr. J7/261/2019, CUI ' +
                                '40722931 și înregistrată la ASF cu codul unic RAJ-502061 ca asistent în brokeraj al ' +
                                'RENOMIA INSURANCE REINSURANCE BROKER SRL.'}
                        </p>

                        {/* Close button */}
                        <button
                            onClick={toggleAboutPopup}
                            className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
                        >
                            Închide
                        </button>
                    </div>
                </div>
            )}

            {/* Popup Modal for Contact */}
            {isContactOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
                    id={'contact-popup'}
                >
                    <div className="bg-white p-5 rounded-md shadow-md w-11/12 max-w-2xl">
                        <h3 className="text-xl font-bold mb-4">{'Contact'}</h3>
                        <div className="text-base text-text-color">
                            <div
                                className="flex flex-col md:flex-row md:gap-3 items-start justify-start mb-3">
                                <span>e-mail:</span>
                                <a href="mailto:doina.tomuleanu@renomia.ro"
                                   className="text-green-600 hover:text-green-800">
                                    doina.tomuleanu@renomia.ro
                                </a>
                                <a href="mailto:gheorghe.tomuleanu@renomia.ro"
                                   className="text-green-600 hover:text-green-800">
                                    gheorghe.tomuleanu@renomia.ro
                                </a>
                            </div>
                            <p className={'flex flex-col mb-3'}>
                                {'Program de lucru in zilele lucratoare legal: '}
                                <br/>
                                {'Luni - Vineri: 09:00 - 17:00'}
                            </p>
                            <div>
                                {'Urgente in afara programului de lucru: Tel/WhathApp: '}
                                <br/>
                                <p className={'flex flex-col md:flex-row md:gap-3 md:p-2'}>
                                    <a href="tel:0740039340" className="text-green-600 hover:text-green-800 ">
                                        0740.039.340
                                    </a>
                                    <a href="tel:0740207134" className="text-green-600 hover:text-green-800 ">
                                        0740.207.134
                                    </a>
                                </p>

                            </div>

                        </div>

                        {/* Close button */}
                        <button
                            onClick={(e) => {
                                e.preventDefault();
                                toggleContactPopup();
                            }}
                            className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
                        >
                        Închide
                        </button>
                    </div>
                </div>
            )}

        </footer>
    );
};